// Values come from public/app-config.js, substituted per stand at container
// start; the fallbacks cover dev, jest (no window) and a missing file.
const settings = (typeof window !== 'undefined' && window.idwellSettings) || {}

export const LOCIZE_SAVE_MISSING = settings.LOCIZE_SAVE_MISSING ?? false

export const LOCIZE_API_KEY = settings.LOCIZE_API_KEY ?? ''

export const LOCIZE_ALLOWED_HOST = settings.LOCIZE_ALLOWED_HOST ?? ''

export const CENTRIFUGE_DOMAIN = settings.CENTRIFUGE_DOMAIN ?? ''
